import axios from 'axios'

import config from '../../config'

const updateAuthUserPassword = (params = {}, data) => {
  const { airportId, id } = params

  const url = `${config.baseUrl}/${airportId}/AuthUsers/${id}/Password`
  return axios.put(url, data)
}

export default updateAuthUserPassword
